const DEFAULT_THEME = {
  "fontSettings": {
      "fonts-url": "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
      "font-family": "'Inter', sans-serif",
      "font-optical-sizing":"auto",
      "font-weight": 300,
      "font-style":"normal",
      "font-size":"12pt"
  },
  "colors": {
      "color_info": "#3c8ef7",
      "color_primary": "#091f68",
      "color_secondary": "#9dcbef",
      "color_background": "#000000",
      "color_main": "#000000",
      "color_white": "#fff",
      "color_black": "#000",
      "color_warning": "#f8d161",
      "color_success": "#4caf50",
      "color_danger": "#f44336",
      "color_gray-100": "#f5f5f5",
      "color_gray-200": "#eeeeee",
      "color_gray-300": "#e0e0e0",
      "color_gray-400": "#bdbdbd",
      "color_gray-500": "#9e9e9e",
      "color_gray-600": "#757575",
      "color_gray-700": "#616161",
      "color_gray-800": "#424242",
      "color_gray-900": "#212121"
  },
};


export default DEFAULT_THEME;